import { render, staticRenderFns } from "./DatafieldValidationStatement.vue?vue&type=template&id=31c1d77f"
import script from "./DatafieldValidationStatement.vue?vue&type=script&lang=js"
export * from "./DatafieldValidationStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports